
import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

const ShowPeriods = props => {

    if (!props.period) return null;

    return (
        <div>
            <tr>
                <td>{ props.period.time }</td>
                <td dangerouslySetInnerHTML={{ __html: props.period.description }}></td>
            </tr>
        </div>
    )
}

const CreateTable = props => {

    if(!props.show) return null;

    return (
        <table className={style['timetable']} cellSpacing="10" cellPadding="10">
            <tbody>
            {props.children}
            </tbody>
        </table>
    )
}

class DetailPageTimetable extends React.Component {

    _getSingleDayTimetable() {

        if (this.props.model && this.props.model.timetable) {

            return (

                this.props.model.timetable.periods.map((period) => {

                    return (
                        <tr>
                            <td>{ period.time }</td>
                            <td dangerouslySetInnerHTML={{ __html: period.description }}></td>
                        </tr>
                    )
                })

            )
        }
    }

    _getMultipleDayTimetable() {

        if (this.props.model && this.props.model.multiple_days) {

            return (
                <div>
                    {this.props.model.multiple_days_events.map(function(event_day) {

                        if (event_day.timetable) {
                            let timetable = event_day.timetable;

                            return (
                                <div>
                                    {timetable.name} Timetable
                                    <table styleName="timetable" cellSpacing="10" cellPadding="10">
                                        <tbody>
                                            {timetable.periods.map(function(period) {
                                                return (
                                                    <div>
                                                        <tr>
                                                            <td>{ period.time }</td>
                                                            <td dangerouslySetInnerHTML={{ __html: period.description }}></td>
                                                        </tr>
                                                    </div>
                                                )
                                                })}
                                        </tbody>
                                    </table>
                                </div>
                            );
                        }
                    })}
                </div>
            )

        }

    }

    render() {

        return (
            <div>

                {!this.props.model.multiple_days && (
                    <CreateTable show={true}>
                        {this._getSingleDayTimetable()}
                    </CreateTable>
                )}

                {this.props.model.multiple_days && (
                    <CreateTable show={true}>
                        {this._getMultipleDayTimetable()}
                    </CreateTable>
                )}
            </div>
        );
    }
}

export default CSSModules(DetailPageTimetable, style);


// WEBPACK FOOTER //
// ./components/DetailPageTimetable/index.js